import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { Anatomy } from './types';

import './AnatomySection.css';

type AnatomySectionProps = {
    data: Anatomy;
};

export function AnatomySection({ data }: AnatomySectionProps) {
    const [ref, inView] = useInView<HTMLElement>();

    return (
        <section
            ref={ref}
            className={`programs-anatomy faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <div className="programs-anatomy__head">
                <span className="programs-eyebrow faves-reveal">{data.eyebrow}</span>
                <h2
                    className="programs-anatomy__heading faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h2>
            </div>
            <div className="programs-anatomy__body">
                <picture
                    className="programs-anatomy__mock faves-reveal"
                    style={{ '--reveal-delay': '180ms' } as React.CSSProperties}
                >
                    <source media="(max-width: 900px)" srcSet={data.mockImageMobile} />
                    <img
                        className="programs-anatomy__mock-img"
                        src={data.mockImage}
                        alt=""
                        aria-hidden="true"
                        loading="lazy"
                        decoding="async"
                    />
                </picture>
                <ul className="programs-anatomy__points">
                    {data.points.map((point, i) => (
                        <li
                            className="programs-anatomy__point faves-reveal"
                            key={point.title}
                            style={{ '--reveal-delay': `${240 + i * 80}ms` } as React.CSSProperties}
                        >
                            <div className="programs-anatomy__point-text">
                                <span className="programs-anatomy__point-title">{point.title}</span>
                                <span className="programs-anatomy__point-desc">{point.description}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
